import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Export a DOM element to PDF
 * @param {string} elementId - The ID of the DOM element to capture
 * @param {string} filename - The PDF filename (without .pdf extension)
 * @param {string} title - Optional title to add at the top of the PDF
 */
export const exportToPDF = async (elementId, filename, title) => {
  const element = document.getElementById(elementId);
  if (!element) {
    throw new Error(`Element #${elementId} not found`);
  }

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: "#ffffff"
  });

  const imgData = canvas.toDataURL("image/png");
  const imgWidth = canvas.width;
  const imgHeight = canvas.height;

  // A4 landscape for wide content, portrait for narrow
  const isWide = imgWidth > imgHeight * 1.2;
  const pdf = new jsPDF({
    orientation: isWide ? "landscape" : "portrait",
    unit: "mm",
    format: "a4"
  });

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  // Add title if provided
  let yOffset = 10;
  if (title) {
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    pdf.text(title, 10, yOffset + 5);
    pdf.setFontSize(9);
    pdf.setFont("helvetica", "normal");
    pdf.text(`Exporté le ${new Date().toLocaleDateString("fr-FR")}`, 10, yOffset + 12);
    yOffset += 18;
  }

  const availableHeight = pdfHeight - yOffset - 10;
  const ratio = Math.min(
    (pdfWidth - 20) / imgWidth,
    availableHeight / imgHeight
  );
  const scaledWidth = imgWidth * ratio;
  const scaledHeight = imgHeight * ratio;

  pdf.addImage(imgData, "PNG", 10, yOffset, scaledWidth, scaledHeight);
  pdf.save(`${filename}.pdf`);
};
